import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConsentHistoryResponse } from './consent-record.model';

/**
 * TVG-344: HTTP wrapper for a contact's consent history. Read-only — records
 * are written by the server whenever a permission is given or changed.
 */
@Injectable({
  providedIn: 'root',
})
export class ConsentRecordService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  listForContact(contactId: number | string): Observable<ConsentHistoryResponse> {
    return this.http.get<ConsentHistoryResponse>(`${this.apiUrl}/api/contacts/${contactId}/consent-records`);
  }
}
